module.exports = __webpack_public_path__ + "downloads/Profile.c5666c8e.pdf";